/* tslint:disable */
/* eslint-disable */
/**
 * Bank API Schema
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface GetFraudLockedCardTransaction200ResponseOneOfEvidenceListInnerErrors
 */
export interface GetFraudLockedCardTransaction200ResponseOneOfEvidenceListInnerErrors {
    /**
     * 
     * @type {string}
     * @memberof GetFraudLockedCardTransaction200ResponseOneOfEvidenceListInnerErrors
     */
    'detectedDpi'?: GetFraudLockedCardTransaction200ResponseOneOfEvidenceListInnerErrorsDetectedDpiEnum;
    /**
     * 
     * @type {string}
     * @memberof GetFraudLockedCardTransaction200ResponseOneOfEvidenceListInnerErrors
     */
    'calculatedDpi'?: GetFraudLockedCardTransaction200ResponseOneOfEvidenceListInnerErrorsCalculatedDpiEnum;
    /**
     * 
     * @type {string}
     * @memberof GetFraudLockedCardTransaction200ResponseOneOfEvidenceListInnerErrors
     */
    'colorGradation'?: GetFraudLockedCardTransaction200ResponseOneOfEvidenceListInnerErrorsColorGradationEnum;
    /**
     * 
     * @type {string}
     * @memberof GetFraudLockedCardTransaction200ResponseOneOfEvidenceListInnerErrors
     */
    'heightMillis'?: GetFraudLockedCardTransaction200ResponseOneOfEvidenceListInnerErrorsHeightMillisEnum;
    /**
     * 
     * @type {string}
     * @memberof GetFraudLockedCardTransaction200ResponseOneOfEvidenceListInnerErrors
     */
    'widthMillis'?: GetFraudLockedCardTransaction200ResponseOneOfEvidenceListInnerErrorsWidthMillisEnum;
}

export const GetFraudLockedCardTransaction200ResponseOneOfEvidenceListInnerErrorsDetectedDpiEnum = {
    insufficient: 'INSUFFICIENT',
    unknown: 'UNKNOWN'
} as const;

export type GetFraudLockedCardTransaction200ResponseOneOfEvidenceListInnerErrorsDetectedDpiEnum = typeof GetFraudLockedCardTransaction200ResponseOneOfEvidenceListInnerErrorsDetectedDpiEnum[keyof typeof GetFraudLockedCardTransaction200ResponseOneOfEvidenceListInnerErrorsDetectedDpiEnum];
export const GetFraudLockedCardTransaction200ResponseOneOfEvidenceListInnerErrorsCalculatedDpiEnum = {
    pixelsInsufficient: 'PIXELS_INSUFFICIENT',
    pixelsRequired: 'PIXELS_REQUIRED',
    realSizeRequired: 'REAL_SIZE_REQUIRED',
    insufficient: 'INSUFFICIENT',
    unknown: 'UNKNOWN'
} as const;

export type GetFraudLockedCardTransaction200ResponseOneOfEvidenceListInnerErrorsCalculatedDpiEnum = typeof GetFraudLockedCardTransaction200ResponseOneOfEvidenceListInnerErrorsCalculatedDpiEnum[keyof typeof GetFraudLockedCardTransaction200ResponseOneOfEvidenceListInnerErrorsCalculatedDpiEnum];
export const GetFraudLockedCardTransaction200ResponseOneOfEvidenceListInnerErrorsColorGradationEnum = {
    required: 'REQUIRED',
    insufficient: 'INSUFFICIENT'
} as const;

export type GetFraudLockedCardTransaction200ResponseOneOfEvidenceListInnerErrorsColorGradationEnum = typeof GetFraudLockedCardTransaction200ResponseOneOfEvidenceListInnerErrorsColorGradationEnum[keyof typeof GetFraudLockedCardTransaction200ResponseOneOfEvidenceListInnerErrorsColorGradationEnum];
export const GetFraudLockedCardTransaction200ResponseOneOfEvidenceListInnerErrorsHeightMillisEnum = {
    required: 'REQUIRED'
} as const;

export type GetFraudLockedCardTransaction200ResponseOneOfEvidenceListInnerErrorsHeightMillisEnum = typeof GetFraudLockedCardTransaction200ResponseOneOfEvidenceListInnerErrorsHeightMillisEnum[keyof typeof GetFraudLockedCardTransaction200ResponseOneOfEvidenceListInnerErrorsHeightMillisEnum];
export const GetFraudLockedCardTransaction200ResponseOneOfEvidenceListInnerErrorsWidthMillisEnum = {
    required: 'REQUIRED'
} as const;

export type GetFraudLockedCardTransaction200ResponseOneOfEvidenceListInnerErrorsWidthMillisEnum = typeof GetFraudLockedCardTransaction200ResponseOneOfEvidenceListInnerErrorsWidthMillisEnum[keyof typeof GetFraudLockedCardTransaction200ResponseOneOfEvidenceListInnerErrorsWidthMillisEnum];


